import React, { useState } from 'react';
import { PAYMENT_STATES, PAYMENT_TYPES } from 'utils/Constants';
import DayJs from 'utils/Dayjs';

import Modal from 'components/Modal';
import Action from 'components/Misc/Action';
import { Button, Datepicker, Currency, Select } from 'components/Misc/Form';

import { useStudentPaymentStore } from 'store/user/useStudentPaymentStore';

const INITIAL = {
	type: '',
	paid: '',
	amount: '',
	state: 'scheduled',
	deadlineAt: DayJs()
};

const Add = ({ gradeId }) => {
	// Store modal's visibility
	const [modal, setModal] = useState(false);

	// Store payment's data
	const [data, setData] = useState(INITIAL);

	// Use user's creation store
	const onAddPayment = useStudentPaymentStore(state => state.onAddPayment);

	// Handle payment addition for student
	const onAdd = () => {
		// Reset data state
		setData(INITIAL);

		// Hide modal
		handleModal();

		// Add payment to store
		onAddPayment(gradeId, data);
	};

	// Handle payment data change
	const onChange = ({ name, value }) => {
		setData(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Toggle modal's visibility
	const handleModal = () => setModal(m => !m);

	return (
		<>
			<Action
				icon="shopping_cart"
				title="Pievienot maksājumu"
				subtitle="Izveidot pielāgotu maksājumu"
				onClick={handleModal}
			/>
		
			<Modal title="Izveidot maksājumu grafiku" visible={modal} handleModal={handleModal}>
				<div className="grid grid-cols-2 gap-4">
					<Select
						name="type"
						label="Tips"
						placeholder=" "
						value={data.type}
						onChange={onChange}
						options={PAYMENT_TYPES.map(type => ({
							value: type.value, name: type.text
						}))}
					/>

					<Select
						name="state"
						label="Statuss"
						placeholder=" "
						value={data.state}
						onChange={onChange}
						options={PAYMENT_STATES.map(state => ({
							value: state.value, name: state.text
						}))}
					/>

					<Currency
						name="amount"
						label="Maksājamā summa"
						value={data.amount}
						onChange={onChange}
					/>

					<Currency
						name="paid"
						label="Apmaksātā summa"
						value={data.paid}
						onChange={onChange}
					/>

					<Datepicker
						end
						asInput
						name="deadlineAt"
						label="Termiņš"
						value={data.deadlineAt}
						onChange={onChange}
					/>

					<div className="col-span-2 flex justify-end">
						<Button
							icon="check"
							theme="success"
							value="Pievienot"
							onClick={onAdd}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
};

export default Add;